import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "store";
import logger from "utils/logger";

const useOpenTpsc = () => {
    const tpsUrl = useSelector((state: RootState) => state.config.tpscBaseUrl, shallowEqual);
    const { i18n } = useTranslation()
    
    const openTpsc = (vmID?: string | number) => {
        if (tpsUrl) {
            window.open(`${tpsUrl}${vmID}?lang=${i18n.language}`, '_blank');
        }
        else {
            logger.noticeError(`[Open TPSC]: Not able to open the review/start scenario due to TPSClould base path was missing`);
        }
    }

    return {
        openTpsc
    }
}

export default useOpenTpsc;
